import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './search.module.scss';
import HamburgerClose from './HamburgerClose';
import IconWrapper from './IconWrapper';

class Search extends React.PureComponent {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      window._st = null;
      window.swiftype && window.swiftype();
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.searching) {
      this.input.focus();
    }
  }

  render() {
    const {
      searching,
      toggleSearching,
      setActivePrimaryTab,
      showMobileMenu,
    } = this.props;

    const classes = classnames(
      styles.search,
      searching && styles.searching
    );

    return (
      <div className={classes}>
        <IconWrapper
          onClick={() => toggleSearching(true)}
          icon="searchRebrand"
          className={styles['search-icon']}
        />

        <input
          className={classnames(styles.input, 'swiftype-search')}
          data-search-input=""
          name="query"
          placeholder=" e.g. What is life insurance?"
          ref={(input) => { this.input = input; }}
          type="text"
        />

        <IconWrapper
          icon="searchRebrand"
          className={classnames(styles['search-icon-mobile'], 'st-search-show-outputs')}
        />

        <HamburgerClose
          showMobileMenu={showMobileMenu}
          searching={searching}
          toggleSearching={toggleSearching}
          toggleMobileMenu={this.props.toggleMobileMenu}
        />

        <IconWrapper
          onClick={() => setActivePrimaryTab('about')}
          icon="overflow"
          className={styles['overflow-icon']}
        />
      </div>
    );
  }
}

Search.propTypes = {
  searching: PropTypes.bool,
  toggleSearching: PropTypes.func,
  toggleMobileMenu: PropTypes.func,
  showMobileMenu: PropTypes.bool,
  setActivePrimaryTab: PropTypes.func,
};

export default Search;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Search/index.js